import { create } from 'zustand';
import { resetVariablesData } from '../../data/variablesDataApi';
import { createComponentSlice } from './createComponentSlice';
import { createDocumentSlice } from './createDocumentSlice';
import { createDocumentTemplateSlice } from './createDocumentTemplateSlice';
import { createDocumentUrlSlice } from './createDocumentUrlSlice';
import { createDrawerCloseHandlerSlice } from './createDrawerCloseHandlerSlice';
import { createEditDesktopModalSlice } from './createEditDesktopModalSlice';
import { createLoaderSlice } from './createLoaderSlice';
import { createSFUserContextSlice } from './createSFUserContextSlice';
import { createSignatureRequestSlice } from './createSignatureRequestSlice';
import { createTemplateMetadataSlice } from './createTemplateMetadataSlice';
import { createUploadDocxFileModalSlice } from './createUploadDocxFileModalSlice';
import { createDownloadUrlSlice } from './createUrlSlice';
import { createVariablesSlice } from './createVariablesSlice';
import { AppStore } from './types';

export const storeResetFns = new Set<() => void>();

export const useAppStore = create<AppStore & { resetStore: () => void }>((...args) => ({
	...createSFUserContextSlice(...args),
	...createComponentSlice(...args),
	...createDocumentTemplateSlice(...args),
	...createLoaderSlice(...args),
	...createDownloadUrlSlice(...args),
	...createDocumentSlice(...args),
	...createVariablesSlice(...args),
	...createTemplateMetadataSlice(...args),
	...createSignatureRequestSlice(...args),
	...createDrawerCloseHandlerSlice(...args),
	...createDocumentUrlSlice(...args),
	...createEditDesktopModalSlice(...args),
	...createUploadDocxFileModalSlice(...args),
	resetStore: () => {
		storeResetFns.forEach(fn => fn());
		resetVariablesData();
	},
}));
